import React from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
} from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom"; // <-- import useParams here
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import { addFeedback } from "../../../api/feedback";
import useCustomValidation from "../validationSchema";

const AddFeedback = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { dealId } = useParams();
  const { setData, loading, error, success } = useResponse(
    (data) => addFeedback(data, dealId),
    () => {
      navigate(`/deals/show/${dealId}`);
    }
  );

  const initialValues = {
    clientSatisfaction: "",
    campaignDelivered: false,
    upsellPotential: false,
    notes: "",
  };
  const { feedbackSchema } = useCustomValidation();

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={`${t("btns.Add")} ${t("Feedback")}`} />

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={feedbackSchema}
          onSubmit={(values) => {
            setData({ data: values, type: "add" });
          }}
        >
          {(formik) => (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              <Row>
                <Col md="6">
                  <FormGroup check>
                    <Label check className="mb-0 ms-2">
                      <Input
                        type="checkbox"
                        name="campaignDelivered"
                        checked={formik.values.campaignDelivered}
                        onChange={formik.handleChange}
                      />
                      {t("Campaign Delivered")}
                    </Label>
                  </FormGroup>
                </Col>

                <Col md="6">
                  <FormGroup check>
                    <Label check className="mb-0 ms-2">
                      <Input
                        type="checkbox"
                        name="upsellPotential"
                        checked={formik.values.upsellPotential}
                        onChange={formik.handleChange}
                      />
                      {t("Upsell Potential")}
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>{t("Client Satisfaction")}</Label>
                    <Input
                      type="text"
                      name="clientSatisfaction"
                      placeholder={t("Client Satisfaction")}
                      value={formik.values.clientSatisfaction}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={
                        formik.touched.clientSatisfaction &&
                        !!formik.errors.clientSatisfaction
                      }
                    />
                    <FormFeedback>
                      {formik.errors.clientSatisfaction}
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup>
                    <Label>{t("Notes")}</Label>
                    <Input
                      type="textarea"
                      name="notes"
                      placeholder={t("Notes")}
                      value={formik.values.notes}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                  </FormGroup>
                </Col>
              </Row>

              <FormButtonHandler btnTxt={t("Add")} loading={loading} />

              <ResultHandler
                error={error}
                success={success}
                successMsg={t("Created Successfully!")}
              />
            </Form>
          )}
        </Formik>
      </Container>
    </div>
  );
};

export default AddFeedback;
